'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const styled = require('styled-components');
const styled__default = _interopDefault(styled);
const universal_color = require('../../../style/universal.color.js');
const icon_style = require('../icon.style.js');

var liveYellow = universal_color.liveYellow,
    ticketGreen = universal_color.ticketGreen; // TODO: Remove this for a better alternative (preferably fixing the mlb-icons
// generation method)
// These are a bunch of specific style overrides for some new icons added
// to mlb-icons that are broken due to issues with the json-generator

var Audio2Wrapper = styled__default(icon_style.IconWrapper).withConfig({
  displayName: "styleOverrides__Audio2Wrapper",
  componentId: "sc-1ezwx7v-0"
})(["use{g{stroke:", ";stroke-width:2;path{fill:none;}rect{&:nth-child(4),&:nth-child(5){stroke-width:1;fill:", ";}}}}"], function (_ref) {
  var fill = _ref.fill;
  return fill;
}, function (_ref2) {
  var fill = _ref2.fill;
  return fill;
});
var SadBaseballWrapper = styled__default(icon_style.IconWrapper).withConfig({
  displayName: "styleOverrides__SadBaseballWrapper",
  componentId: "sc-1ezwx7v-1"
})(["use{g{path{&:first-of-type,&:nth-child(3),&:nth-child(5){fill:none;}}}}"]);
var Gameday2Wrapper = styled__default(icon_style.IconWrapper).withConfig({
  displayName: "styleOverrides__Gameday2Wrapper",
  componentId: "sc-1ezwx7v-2"
})(["use{path{stroke:", ";stroke-width:2;}}"], function (_ref3) {
  var fill = _ref3.fill;
  return fill;
});
var PreviewWrapper = styled__default(icon_style.IconWrapper).withConfig({
  displayName: "styleOverrides__PreviewWrapper",
  componentId: "sc-1ezwx7v-3"
})(["use{path{stroke-width:.5;}rect{stroke-width:2;}}"]);
var Tickets2Wrapper = styled__default(icon_style.IconWrapper).withConfig({
  displayName: "styleOverrides__Tickets2Wrapper",
  componentId: "sc-1ezwx7v-4"
})(["use{g{path{&:first-of-type{fill:transparent;}&:nth-child(3){fill-opacity:.25;stroke:", ";stroke-width:2;}}}}"], function (_ref4) {
  var fill = _ref4.fill;
  return fill;
});
var WrapWrapper = styled__default(icon_style.IconWrapper).withConfig({
  displayName: "styleOverrides__WrapWrapper",
  componentId: "sc-1ezwx7v-5"
})(["use{g{rect{stroke-width:2;}path{stroke:", ";&:first-of-type{stroke:transparent;}}}}"], function (_ref5) {
  var fill = _ref5.fill;
  return fill;
});
var IconWrapperOverrides = {
  'audio-2': Audio2Wrapper,
  'gameday-2': Gameday2Wrapper,
  'box': Gameday2Wrapper,
  'preview': PreviewWrapper,
  'tickets-2': Tickets2Wrapper,
  'wrap': WrapWrapper,
  'sad-baseball': SadBaseballWrapper
};
var IconColorOverrides = {
  'tv-live': liveYellow,
  'tickets-2': ticketGreen
};

exports.IconColorOverrides = IconColorOverrides;
exports.IconWrapperOverrides = IconWrapperOverrides;
